/**
 * Purpose registry — WHY the document exists. Industry-independent by design:
 * Grand Opening works for a restaurant, a salon, a gym, or a hospital.
 * Offer-driven purposes require the document to support offers (checked
 * against Phase 2 knowledge), so a Certificate never advertises a Sale.
 */

export const PURPOSES = [
  { id: 'sale', name: 'Sale', requiresCapabilities: ['supportsOffers'] },
  { id: 'grand-opening', name: 'Grand Opening' },
  { id: 'discount', name: 'Discount', requiresCapabilities: ['supportsOffers'] },
  { id: 'launch', name: 'Launch' },
  { id: 'hiring', name: 'Hiring' },
  { id: 'workshop', name: 'Workshop' },
  { id: 'invitation', name: 'Invitation' },
  { id: 'awareness', name: 'Awareness' },
  { id: 'holiday', name: 'Holiday' },
  { id: 'festival', name: 'Festival' },
  { id: 'promotion', name: 'Promotion', requiresCapabilities: ['supportsOffers'] },
  { id: 'membership', name: 'Membership' },
  { id: 'event', name: 'Event' },
  { id: 'announcement', name: 'Announcement' },
  { id: 'new-arrival', name: 'New Arrival', requiresCapabilities: ['supportsOffers'] },
  { id: 'offer', name: 'Offer', requiresCapabilities: ['supportsOffers'] },
  { id: 'thank-you', name: 'Thank You' },
  { id: 'congratulations', name: 'Congratulations' },
  { id: 'anniversary', name: 'Anniversary' },
  { id: 'fundraiser', name: 'Fundraiser' },
  { id: 'webinar', name: 'Webinar' },
  { id: 'reopening', name: 'Reopening' },
];
